module.exports = "<p>\n  tiny-mce works!\n</p>\n  <span\n    class=\"help-block text-muted\"\n    *ngIf=\"input.description!=''\"\n  >{{ input.description }}</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ing-dynamic-form/dynamic-form/child-item/child-item.component.html
// module id = 1248
// module chunks = 13